
<template>
  <div class="box">
    <!-- 导航 -->
    <nav-bar />
    <!-- banner start -->
    <div class="pcban">
      <!-- <banner
        :bannerSrc="bannerList.src"
        isnum="yewu"
      /> -->
      <banner
        :bannerSrc="bannerList.src"
        isnum="yewu"
      />
      <div class="text1 wow bounceInLeft animated">艺识代知识产权/Easytimes IP</div>
      <div class="text2 wow bounceInLeft animated">"一站式,全方位"知识产权专业服务平台</div>
      <div class="text3 wow bounceInLeft animated">Full-range IP Service Platform</div>
    </div>
    <div class="medban">
      <banner
        :bannerSrc="bannerList.srcmedban"
        isnum="yewu"
      />
      <div class="text1 wow bounceInLeft animated">艺识代知识产权/Easytimes IP</div>
      <div class="text2 wow bounceInLeft animated">"一站式,全方位"知识产权专业服务平台</div>
      <div class="text3 wow bounceInLeft animated">Full-range IP Service Platform</div>
    </div>
    <!-- 知识产权代管服务 start -->
    <intellectual-property />
    <!-- 知识产权代管服务 start -->
    <div class="medban"><special-intellectual /></div>
    <div class="pcban"><special-intellectual-xin /></div>

    <!-- 页脚 start -->
    <footers />
  </div>
</template>
<script>
//业务介绍
import NavBar from "@/components/NavBar";
import Banner from "@/components/Banner";
import Footers from "@/components/Footer";
import IntellectualProperty from "./component/IntellectualProperty";
import SpecialIntellectual from "./component/SpecialIntellectual";
import SpecialIntellectualXin from "./component/SpecialIntellectualXin";


export default {
  name: "BusinessIntroduction",
  components: {
    NavBar,
    Banner,
    Footers,
    IntellectualProperty,
    SpecialIntellectual,
    SpecialIntellectualXin,

  },
  data() {
    return {
      lange: this.$cookies.getCookie("language"),
      bannerList:{},
    };
  },
  created() {
    this.bannerImg();
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
  destroyed() {
    location.reload();
  },
  methods: {
     bannerImg (){
        var _this = this;
          _this.bannerList = _this.lange == "ch"
          ?{src:require('../../assets/images/banner_7.png'),srcmedban:require('../../assets/images/banner_7a.png')}
          :{src:require('../../assets/images/banner_7.png'),srcmedban:require('../../assets/images/banner_7a.png')};
          console.info(this.bannerList);
        },
  },
};
</script>
<style scoped>
.box {
  width: 100%;
  display: block;
  position: relative;
}
.pcban {
  display: none;
  position: relative;
}
.pcban .text1{
  position: absolute;
  top: 32%;
  left:46%;
  font-size: 28px;
  color: #bda67d;
  font-family: "黑体", "微软雅黑", sans-serif;
  font-weight: 400;
}
.pcban .text2{
  position: absolute;
  color: #fff;
  top: 45%;
  left: 46%;
  font-family: "黑体", "微软雅黑", sans-serif;
  font-weight: 700;
  font-size: 34px;
}
.pcban .text3{
  position: absolute;
  color: #fff;  
  top: 57%;
  left: 46.5%;
  font-family: "黑体", "微软雅黑", sans-serif;
  font-weight: 700;
  font-size: 24px;
}
.medban {
  display: none;
  position: relative;
}
.medban .text1{
  position: absolute;
  top: 30%;
  right:5%;
  font-size: 14px;
  color: #bda67d;
  font-family: "黑体", "微软雅黑", sans-serif;
  font-weight: 400;
}
.medban .text2{
  position: absolute;
  color: #fff;
  top: 45%;
  right: 4%;
  font-family: "黑体", "微软雅黑", sans-serif;
  font-weight: 700;
  font-size: 16px;
}
.medban .text3{
  position: absolute;
  color: #fff;
  top: 58%;
  right: 5%;
  font-family: "黑体", "微软雅黑", sans-serif;
  font-weight: 700;
  font-size: 14px;
}
.xd_1 {
  width: 100%;
  display: none;
}
.xd_2 {
  width: 100%;
  display: block;
}
@media only screen and (max-width: 1920px) {
  .pcban {
    display: block;
  }
  .medban {
    display: none;
  }
}
@media only screen and (max-width: 768px) {
  .xd_1 {
    display: block;
  }
  .xd_2 {
    display: none;
  }
}
@media only screen and (max-width: 425px) {
  .pcban {
    display: none;
  }
  .medban {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/BusinessIntroduction/index.vue